import "./AboutMe.css";
import { useGetAboutMeQuery, useGetHomeDetailsQuery } from "../../Api/api";
import { useEffect, useState } from "react";
import decor1 from "../../images/decoration/dots-1.png";
import reactagle from "../../images/decoration/Rectangle-7.png";
import shady from "../../images/decoration/dots.png";
import mail from '../../images/Programmer-pana.png'

const AboutMe = () => {
  return (
    <>
      <main id="about">
        <div className="aboutMe-container">
          <div className="about-decor">
            <div className="about-dots">
              <img src={decor1} alt="" />
            </div>
            <div className="about-rect">
              <img src={reactagle} alt="" />
            </div>
            <div className="about-shady">
              <img src={shady} alt="" />
            </div>
          </div>
          <div className="abouMe-row">
            <div
              className=" col-lg-6 col-md-5 col-sm-12 about-img"
              data-aos="fade-up-right"
            >
              <img
              src={mail}
                 alt=""
              />
            </div>
            <div
              className=" col-lg-6 col-md-7  col-sm-12 about_myinfo"
              data-aos="fade-up-left"
            >
              <div className="title">
                <h2>ABOUT ME</h2>
                <h3>Why Hire me for Your Project</h3>
              </div>
              <div className="about-description">
                <div id="foo" unselectable="on" class="unselectable">
                  <>
                    <p>
                      {" "}
                      I'm 22 years old creative{" "}
                      <strong>SOFTWARE DEVELOPER  </strong>
                      based in {" "}
                      <a href="#">
                        <strong>SINDH, HYDERABAD </strong>
                      </a>
                      specializing in Website Design and Development. I build
                      clean, appealing, and functional interfaces which comply
                      with the latest web standards
                    </p>
                  </>
                </div>
              </div>

              <div className="itscv">
                <a
                  href="https://drive.google.com/file/d/1DhLZRpSpdQX0zTun2qxV5n9QZzLPHRdO/view?usp=sharing"
                  download="DiyaRam_Resume.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="download-cv">
                    Download Cv <i class="bx bx-download"></i>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default AboutMe;
